import type { EngineAuraLook } from './types';

// Stronger Story breathing, with the hotspots kept in front.
export const STORY_AURA_CONFIG: EngineAuraLook = {
  sizeMultiplier: 3.4,
  liftMultiplier: 0.005,
  zoom: 1,
  flowSpeed: 0.04,
  noiseScale: 1.5,
  warpStrength: 1.2,
  swirlSpeed: 1.1,
  frequency: 5.3,
  pulseSpeed: 0,
  baseColor: '#cc0000',
  vignetteFeather: 0.18,
  opacity: 0.85,
  octaves: 3,
  trailSamples: 1,
  trailLength: 0.18,
  trailDecay: 0.21,
  ringScale: 12.9,
  brightness: 2,
  gamma: 0.8,
  breathMin: 0.8,
  breathMax: 1.5,
  breathSeconds: 8,
  breathPeakAt: 0.5,
  sharpness: 1.8,
  vignetteRadius: 0.475,
  coreOpacity: 0,
  coreRadius: 0.06,
  coreFeather: 0.08,
};
